import type { Ref, RefObject } from 'react';

const isRefObject = <T = unknown>(ref: Ref<T>): ref is RefObject<T> =>
  typeof ref === 'object' && ref !== null && 'current' in ref;

export { isRefObject };
